<!--
 * @Author: cmchiu
 * @Date: 2023-04-06 16:29:13
 * @LastEditTime: 2023-04-27 11:14:20
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\layout\AppHeader\components\Navbar\index.vue
 * 
-->
<template>
    <nav class="navbar__content d-flex align-items-center">
        <!-- 手機漢堡選單按鈕 -->
        <input type="checkbox" id="menu" />
        <label for="menu" class="menu-btn"></label>

        <ul class="navbar__list d-flex align-items-center">
            <form id="sub-menu" class="sub-menu">
                <submenu v-for="route in routes" :key="route.MenuID" :item="route" />
            </form>
        </ul>

        <button class="navbar__contact">
            <!-- <a href="./about"> 聯絡我們 </a> -->
            <router-link :to="{ path: '/contact' }"> 聯絡我們 </router-link>
        </button>
    </nav>
</template>

<script>
import XEUtils from 'xe-utils'
import { getMenu } from '@/api/common'
import submenu from './submenu'

export default {
    name: 'navbar',

    components: { submenu },

    data() {
        return {
            configs: {
                loading: false,
            },
            routes: [],
        }
    },

    created() {
        this.getMenu()
    },

    methods: {
        async getMenu() {
            const vm = this
            vm.configs.loading = true
            await getMenu({ visible: true })
                .then(res => {
                    // handle success
                    // vm.routes = res.Items
                    vm.routes = XEUtils.toArrayTree(res.Items, {
                        strict: true,
                        key: 'MenuID',
                        parentKey: 'UpperMenuID',
                        children: 'children',
                        sortKey: 'sort',
                    })
                })
                .catch(err => {
                    // handle error
                    vm.routes = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },
    },
}
</script>
